import Promise from 'bluebird';
import React, { useCallback, useMemo } from 'react';

import { ChartDataAdapter } from '@bingads-webui-campaign-react/inline-chart';
import appConfig from '@bingads-webui-component-legacy/config/index';

import { InlineChartPreferences } from '@bingads-webui-campaign/inline-chart-preferences';
import { store, adapter } from '@bingads-webui-component-legacy/bingads-grid/service/grid-preferences';
import preferenceServiceLegacy from '@bingads-webui-component-legacy/preference/service/index';
import globalPageContext from '@bingads-webui-static-legacy/page-context';
import appState from '@bingads-webui-component-legacy/state/index';

import { AssetLibraryInlineChartWrapper } from './inline-chart-wrapper';

export const useAssetLibraryInlineChart = ({
  serverContext, globalLegacyI18n, getPageContext, forceToResizeChart,
}) => {
  const pageContext = useMemo(() => (getPageContext ? getPageContext() : globalPageContext), [getPageContext]);
  const i18nInlineChart = useMemo(() => globalLegacyI18n && globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!@bingads-webui-campaign-react/inline-chart'), [globalLegacyI18n]);

  const chartPreference = useMemo(() => {
    const preferencePromise = preferenceServiceLegacy.initialize().then(() => Promise.promisifyAll(preferenceServiceLegacy));
    return new InlineChartPreferences(
      store,
      appConfig,
      adapter,
      preferencePromise
    );
  }, []);

  const chartDataAdapter = useMemo(() => new ChartDataAdapter({
    i18n: i18nInlineChart,
    permissions: pageContext.Permissions,
    gridName: pageContext.CurrentGridName,
    lowestSupportedGranularity: 'Day',
  }), [i18nInlineChart, pageContext]);

  const getChartPreference = useCallback(() => chartDataAdapter.getPreferencesAndDefaults(
    chartPreference,
    pageContext
  ), [chartDataAdapter, chartPreference, pageContext]);

  const getPerfTimeSeriesParams = useCallback(({ perfMetricDateRange }) => getChartPreference().then((chartParams) => {
    const perfTimeSeriesParamsInner = chartDataAdapter.formatPreferenceValue(perfMetricDateRange, chartParams);
    return perfTimeSeriesParamsInner;
  }), [chartDataAdapter, getChartPreference]);

  pageContext.CurrentTabId = 'Asset';

  const renderInlineChart = ({
    isChartShown, filters, loadPerfTimeSeriesData, perfMetricDateRange,
  }) => (
    <AssetLibraryInlineChartWrapper
      isShowChart={isChartShown}
      serverContext={serverContext}
      loadPerfTimeSeriesData={loadPerfTimeSeriesData}
      dateFilter={perfMetricDateRange}
      chartPreference={chartPreference}
      pageContext={pageContext}
      i18nInlineChart={i18nInlineChart}
      filters={filters}
      appState={appState}
      forceToResizeChart={forceToResizeChart}
    />
  );

  return { getPerfTimeSeriesParams, renderInlineChart, getChartPreference };
};
